/* DON'T EDIT THIS FILE: edit original and run build again */ export const getDownloadAttachmentErrorMessage = (message: string) =>
  ({
    "storage/object-not-found": "El archivo fue eliminado del servidor",
  }[message] || "Hubo un error al descargar el archivo");
